module.exports = __webpack_public_path__ + "img/22.8494c667.png";